import * as Yup from 'yup';
import { NonStandardState } from '@models';

export function useValidationSchema() {
  return Yup.object<NonStandardState>().shape({
    name: Yup.string().nullable().required(),
  });
}
